import { render, staticRenderFns } from "./TransitionSupportPopup.vue?vue&type=template&id=360d72be&scoped=true&"
import script from "./TransitionSupportPopup.vue?vue&type=script&lang=js&"
export * from "./TransitionSupportPopup.vue?vue&type=script&lang=js&"
import style0 from "./TransitionSupportPopup.vue?vue&type=style&index=0&id=360d72be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d72be",
  null
  
)

export default component.exports